<template>
  <div class="action-cards ut-card-base">

    <h3 class="general-title">Keep us in the loop</h3>

    <div class="action-card"
         @click="showModal('message-lead-modal')">
      <h4 class="title message">Write a general update</h4>
    </div>

    <div class="action-card"
         v-bind:class="[{disabled: isdisableOnHoldAndClose }, 'action-card']"
         @click="togglePutLeadOnHold">
      <h4 v-bind:class="[isLamOnHold ? 'play' : 'pause', 'title']">
        {{ isLamOnHold ? 'Reactivate lead' : 'Place lead on hold' }}
      </h4>
    </div>

    <div v-bind:class="[ {disabled: isdisableOnHoldAndClose }, 'action-card']"
         @click="showModal('close-lead-modal')">
      <h4 class="title close">Close lead</h4>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import { LeadStateType } from '@/Mapper/LeadStateType';
import { LeadStageType } from '@/Mapper/LeadStageType';

export default {
  name: 'ActionCards',
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
    }),
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
    isLamOnHold() {
      return (this.lam.statetypeid === LeadAgentLeadStateType.On_Hold);
    },
    isdisableOnHoldAndClose() {
      // Make incative if leadStateType is closed (), or leadStageType is listed
      return this.isLamLost() || this.isLamClosed() || (this.isLamActive() && this.isLamListed());
    },
  },
  methods: {
    isLamLost() {
      return (this.lead.leadstateid === LeadStateType.Lost
      || this.lam.statetypeid === LeadAgentLeadStateType.Lost);
    },
    isLamClosed() {
      return (this.lam.statetypeid === LeadAgentLeadStateType.Closed);
    },
    isLamActive() {
      return (this.lam.statetypeid === LeadAgentLeadStateType.Active);
    },
    isLamListed() {
      return (this.lam.stagetypeid === LeadAgentLeadStageType.Listed);
    },
    isLeadSold() {
      return ([LeadStageType.Sold, LeadStageType.Reviewed].includes(this.lead.leadstageid));
    },
    showModal(name) {
      if (!this.isdisableOnHoldAndClose || name === 'message-lead-modal') {
        this.$modal.show(name);
      }
    },
    togglePutLeadOnHold() {
      if (this.isdisableOnHoldAndClose) {
        return false;
      }

      if (!this.isLamOnHold) {
        this.showModal('on-hold-modal');
      } else {
        this.reactivateLam();
      }

      return true;
    },
    reactivateLam() {
      const payload = {
        lamid: this.lam.id,
        data: {
          statetypeid: LeadAgentLeadStateType.Active,
          oauserid: this.user ? this.user.id : '',
          oauserkey: this.user ? this.user.key : '',
        },
      };
      this.$store
        .dispatch('leadAgentMappingStore/updateLeadAgentMapping', payload)
        .then(() => {
        // this.closeModal();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

</script>

<style lang="scss" scoped>

.general-title {
  @apply ut-font-bold ut-mb-4;
  color: #1B1B1A;
  font-size: 16px;
  line-height: 24px;
}

.action-cards {
  min-height: 296px;

  :hover {
    cursor: pointer;
  }
  @apply ut-mb-6 ut-pb-0;
}

.action-card {

  border-top: 1px solid #E6E5E3;

  &.disabled {

    .title {
     @apply ut-opacity-50 ut-cursor-not-allowed;

      &:before {
        background-color: #545352;
      }

    }

  }

  .title {
    @apply ut-py-4 ut-flex ut-content-center ut-items-center ut-relative;
    color: #545352;
    font-size: 16px;
    line-height: 24px;
      @apply ut-pr-8;

    &:before {
      @apply ut-rounded-full ut-overflow-hidden ut-bg-green-400 ut-bg-center ut-bg-no-repeat ut-mr-6 ut-flex-shrink-0;
      content: '';
      width: 40px;
      height: 40px;
      background-size: 20px 20px;
    }

    &.message {
      &:before {
        background-image: url('../assets/styles/frontend-library/images/message-white-solid.svg');
      }
    }

    &.pause {
      &:before {
        background-image: url('../assets/styles/frontend-library/images/pause-white.svg');
        background-size: auto 18px;
      }
    }

    &.play {
      &:before {
        background-image: url('../assets/styles/frontend-library/images/play-white.svg');
      }
    }

    &.close {
      &:before {
        background-image: url('../assets/styles/frontend-library/images/close-white.svg');
      }
    }

    &:after{
      @apply ut-absolute ut-right-0;
      content: url('../assets/styles/frontend-library/images/chevron-right.svg');


    }


  }

}

</style>
